export const updateRolEnviromentAction = (state) => {
  return {
    type: "UPDATE_STATE_ROL_ENVIROMENT",
    payload: state,
  };
};
